export * from './earthquake.service';
import { EarthquakeService } from './earthquake.service';
export * from './pollution.service';
import { PollutionService } from './pollution.service';
export * from './user.service';
import { UserService } from './user.service';
export const APIS = [EarthquakeService, PollutionService, UserService];
